import { render, staticRenderFns } from "./category-list-page.vue?vue&type=template&id=4bb6a0f8&"
import script from "./category-list-page.vue?vue&type=script&lang=js&"
export * from "./category-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports